import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "title text-cyan" }, "Dati bancari", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title text-cyan mt-2" }, "Pagamenti elettronici", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 col-sm-12" }
const _hoisted_5 = { class: "col-md-4 col-sm-12" }
const _hoisted_6 = { class: "col-md-4 col-sm-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Modalità pagamento", -1)
const _hoisted_9 = { class: "form-control" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bank_account_data = _resolveComponent("bank-account-data")!
  const _component_form_input = _resolveComponent("form-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_bank_account_data, {
      value: _ctx.value.bankAccountData
    }, null, 8, ["value"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_form_input, {
          type: "text",
          label: "Email Paypal",
          modelValue: _ctx.value.paypalEmail,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.paypalEmail) = $event)),
          placeholder: "Email Paypal"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_form_input, {
          type: "text",
          label: "Numero Revolut",
          modelValue: _ctx.value.revolutNumber,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.revolutNumber) = $event)),
          placeholder: "Numero Revolut"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("select", _hoisted_9, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalitaPagamentos, (item, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: item
              }, _toDisplayString(item), 9, _hoisted_11))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}